import React, { useRef } from 'react';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import AuthenticatedRoutesMobile from '@client/components/navigation/AuthenticatedRoutesMobile';
import { UnauthenticatedRoutes } from '@client/components/navigation/UnauthenticatedRoutes';
import { LoginSvg } from '@client/components/icons/loginSvg/LoginSvg';
import { LogoutSvg } from '@client/components/icons/logoutSvg/LogoutSvg';
import ReactLink from '@client/components/reactLink/ReactLink';
import { useAnimatedHeight } from '@client/hooks/useAnimateHeight';
import { useLocation } from 'react-router-dom';
import styles from './mobileNavigation.scss';

export const MobileNavigation = ({ isOpen, handleClick }) => {
  const ref = useRef(null);
  const toggle = isOpen ? styles?.open : styles?.closed;
  const [styledHeight] = useAnimatedHeight({ ref });

  const auth = useAuth0();
  const location = useLocation();
  const isAuthenticated = auth?.isAuthenticated;

  const handleLogout = () => {
    auth?.logout?.();
  };

  const handleLogin = () => {
    auth?.loginWithRedirect({
      appState: { targetUrl: location?.pathname },
    });
  };

  return (
    <div className={`${styles?.container} ${toggle}`} onClick={handleClick}>
      <div
        ref={ref}
        style={{ ...styledHeight }}
        className={`${styles?.innerContainer}`}
      >
        <ul className={`${styles?.list}`}>
          {isAuthenticated && <AuthenticatedRoutesMobile />}
          {!isAuthenticated && <UnauthenticatedRoutes />}
        </ul>
        <ul className={`${styles?.list} ${styles.bottomNav}`}>
          <li className={styles.listItem}>
            <ReactLink
              className={styles.link}
              target="_blank"
              to="https://www.hjart-lungfonden.se"
            >
              Gå till hjart-lungfonden.se
            </ReactLink>
          </li>
          <li className={styles.listItem}>
            {!isAuthenticated && (
              <button className={styles.btn} onClick={handleLogin}>
                <LoginSvg />
                <span className={styles.link}>Logga in</span>
              </button>
            )}
            {isAuthenticated && (
              <button className={styles.btn} onClick={handleLogout}>
                <LogoutSvg />
                <span className={styles.link}>Logga ut</span>
              </button>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};
